import { render, staticRenderFns } from "./OptionField.vue?vue&type=template&id=fd0231c4"
import script from "./OptionField.vue?vue&type=script&lang=js"
export * from "./OptionField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports